import { HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Subject, Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { SignedTimetableDataDto } from '@app/data/dtos/mot/signed-timetable.dto';
import { mapDataSignedTimetable } from '@app/data/mappers/mot/signed-timetables.mapper';
import { SignedTimetablesRepository } from '@app/domain/repositories/mot/signed-timetables.repository.contract';
import { ErrorMsgEnum } from '@app/entities/enums/error/error-msg-enum';
import { ErrorCodes } from '@app/entities/models/error/error.model';
import { SignedTimetable } from '@app/entities/models/mot/signed-timetables/signed-timetables.model';
import { Logger } from '@app/services';
import { MSafeAny } from '@app/shared/models/safe-any/safe-any.model';
import { ENV } from '@environments/environment';

import { MTranslateService } from '@mercadona/core/translate';
import { MRepository } from '@mercadona/core/utils/repository';

@Injectable({
  providedIn: 'root'
})
export class SignedTimetablesRepositoryImpl extends MRepository implements SignedTimetablesRepository {
  private logger = new Logger('MotService');

  private onError = new Subject<ErrorMsgEnum>();
  onError$ = this.onError.asObservable();

  readonly url = '/mot/v2/signed-timetables';

  constructor(private translateService: MTranslateService) {
    super(`${ENV.API_URL_MOT}`);
  }

  getSignedTimetables(): Observable<SignedTimetable[]> {
    return this.get<SignedTimetableDataDto>(this.url).pipe(map(mapDataSignedTimetable), catchError(this.handleError));
  }

  getSignedTimetableByDocumentId(documentId: string): Observable<MSafeAny> {
    let params = new HttpParams();
    params = params.set('lang', this.translateService.getActiveLang());

    return this.get(`${this.url}/${documentId}`, { params }).pipe(catchError(this.handleError));
  }

  private handleError = (error: HttpErrorResponse): Observable<MSafeAny> => {
    let errorType;

    switch (error.status) {
      case ErrorCodes.LOCKED:
        errorType = ErrorMsgEnum.SERVICE_LOCKED;
        break;
      case ErrorCodes.SECTION_MAINTENANCE:
        errorType = ErrorMsgEnum.SECTION_MAINTENANCE;
        break;
      default:
        errorType = ErrorMsgEnum.SERVER_ERROR;
        break;
    }

    this.onError.next(errorType);
    this.logger.error(error);

    return of([]);
  };
}
